
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/declaration-of-conformity",
      function () {
        return require("private-next-pages/declaration-of-conformity.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/declaration-of-conformity"])
      });
    }
  